import { defaultPagination } from "../../../reducers/collectionYardsVisitsDetailReducer";
import {
  cleanUpCollectionYardsVisitsDetail,
  setCollectionYardsVisitsDetailPagination,
} from "../../../reducers/collectionYardsVisitsDetailReducer";
import { AppDispatch } from "../../../store";

export const resetCollectionYardsVisitsDetail = (dispatch: AppDispatch): void => {
  dispatch(cleanUpCollectionYardsVisitsDetail());
  dispatch(setCollectionYardsVisitsDetailPagination(defaultPagination));
};
